import React, { Component, Fragment } from 'react';
import { Col, Row, Button } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import AlertModal from '../../../shared/components/Modal';

class AnanmesisTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            idAnamnesisTemplate: null,
            cause: null,
            queryReason: null,
            currentIllness: null,
            colorAlertModal: "",
            messageAlertModal: "",
            showAlertModal: false
        };
    }

    componentDidMount = () => {
        this.getAnamnesisTemplate();
    }

    createAnamnesisTemplate = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pantillas-anamnesis/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                causa_ingreso: this.state.cause,
                motivo_consulta: this.state.queryReason,
                enfermedad_actual: this.state.currentIllness
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            this.setState({
                idAnamnesisTemplate: data.anamnesis_plantilla.id_anamnesis_plantilla,
                cause: data.anamnesis_plantilla.causa_ingreso,
                queryReason: data.anamnesis_plantilla.motivo_consulta,
                currentIllness: data.anamnesis_plantilla.enfermedad_actual,
                colorAlertModal: "success",
                messageAlertModal: "Plantilla de Anamnesis Guardada exitosamente",
                showAlertModal: true
            });
        }).catch((error) => {
            console.log(error);
            this.setState({
                colorAlertModal: "danger",
                messageAlertModal: "Ha ocurrido un error en el servidor",
                showAlertModal: true
            });
        });
    }

    getAnamnesisTemplate = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pantillas-anamnesis/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            this.setState({
                idAnamnesisTemplate: data[0].id_anamnesis_plantilla,
                cause: data[0].causa_ingreso,
                queryReason: data[0].motivo_consulta,
                currentIllness: data[0].enfermedad_actual
            });
        }).catch((error) => {
            console.log("AnamnesisError:", error);
        });
    }

    updateAnamnesisTemplate = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pantillas-anamnesis/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_anamnesis_plantilla: this.state.idAnamnesisTemplate,
                causa_ingreso: this.state.cause,
                motivo_consulta: this.state.queryReason,
                enfermedad_actual: this.state.currentIllness
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            this.setState({
                idAnamnesisTemplate: data.anamnesis_plantilla.id_anamnesis_plantilla,
                cause: data.anamnesis_plantilla.causa_ingreso,
                queryReason: data.anamnesis_plantilla.motivo_consulta,
                currentIllness: data.anamnesis_plantilla.enfermedad_actual,
                colorAlertModal: "success",
                messageAlertModal: "Plantilla de Anamnesis Actualizada exitosamente",
                showAlertModal: true
            });
        }).catch((error) => {
            console.log(error);
            this.setState({
                colorAlertModal: "danger",
                messageAlertModal: "Ha ocurrido un error en el servidor",
                showAlertModal: true
            });
        });
    }

    onOkModal = () => {
        this.setState({
            messageAlertModal: "",
            colorAlertModal: "",
            showAlertModal: false
        });
    }

    onToggleModal = () => {
        this.setState({
            messageAlertModal: "",
            colorAlertModal: "",
            showAlertModal: false
        });
    }

    render() {
        return (<Fragment>
            <div className="card__title">
                <h5 className="bold-text">Anamnesis</h5>
            </div>

            <Row>
                <Col md={3}>
                    <TextField
                        label="Causa de Ingreso"
                        id="select-cause-of-admission"
                        className=" medical-material-form__field"
                        style={{ width: '100%' }}
                        select
                        value={this.state.cause}
                        onChange={(e) => {
                            this.setState({ cause: e.target.value });
                        }}
                        InputLabelProps={{
                            shrink: this.state.cause != null ? true : false
                        }}
                    >
                        <MenuItem value={'Enfermedad general'}> Enfermedad general </MenuItem>
                        <MenuItem value={'Enfermedad professional'}> Enfermedad professional </MenuItem>
                        <MenuItem value={'Evento catastrofico'}> Evento catastrofico </MenuItem>
                        <MenuItem value={'Accidente de trabajo'}>  Accidente de trabajo </MenuItem>
                        <MenuItem value={'Accidente de transito'}> Accidente de transito </MenuItem>
                        <MenuItem value={'Accidente ofidico'}>  Accidente ofidico </MenuItem>
                        <MenuItem value={'Otro tipo de accidente'}> Otro tipo de accidente </MenuItem>
                        <MenuItem value={'Lesion auto infligida'}> Lesion auto infligida </MenuItem>
                        <MenuItem value={'Lesion por agresion'}> Lesion por agresion </MenuItem>
                        <MenuItem value={'Sospecha abuso sexual'}> Sospecha abuso sexual </MenuItem>
                        <MenuItem value={'Sospecha maltrato emocional'}> Sospecha maltrato emocional </MenuItem>
                        <MenuItem value={'Sospecha maltrato fisico'}> Sospecha maltrato fisico </MenuItem>
                        <MenuItem value={'Sospecha violencia sexual'}> Sospecha violencia sexual </MenuItem>
                        <MenuItem value={'Otra'}> Otra </MenuItem>
                    </TextField>
                </Col>
            </Row>

            <br />

            <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
                <div className="form" style={{ width: '100%' }}>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Motivo de Consulta</span>
                        <div className="form__form-group-field">
                            <textarea
                                style={{ width: '100%' }}
                                value={this.state.queryReason}
                                onChange={(event) => {
                                    this.setState({ queryReason: event.target.value });
                                }}
                                required={true}>
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
                <div className="form" style={{ width: '100%' }}>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Enfermedad Actual</span>
                        <div className="form__form-group-field">
                            <textarea
                                style={{ width: '100%' }}
                                value={this.state.currentIllness}
                                onChange={(event) => {
                                    this.setState({ currentIllness: event.target.value });
                                }}
                                required={true}>
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>

            <Button
                color="primary"
                onClick={() => {
                    if (this.state.idAnamnesisTemplate == null) {
                        this.createAnamnesisTemplate();
                    }
                    else {
                        this.updateAnamnesisTemplate();
                    }
                }}
            >
                Guardar
            </Button>

            <AlertModal
                color={this.state.colorAlertModal}
                title={this.state.messageAlertModal}
                modal={this.state.showAlertModal}
                onOk={() => this.onOkModal()}
                toggle={() => this.onToggleModal()}
            />


        </Fragment>);
    }
}

export default AnanmesisTemplate;